import { Button, Grid, Menu, MenuItem } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const LanguageSelector = ({ type = "button" }) => {
    const { i18n } = useTranslation();

    const [anchorEl, setAnchorEl] = useState(null)

    const open = Boolean(anchorEl);

    const languages = useMemo(() => [
        { value: 'en', label: "EN" },
        { value: 'hk', label: "繁" },
        { value: 'cn', label: "简" }
    ], [])

    const selectedLanguage = useMemo(() => i18n.language, [i18n.language]);

    const handleLanguageChange = useCallback((language) => i18n.changeLanguage(language), [i18n]);

    const handleClick = (e) => setAnchorEl(e.currentTarget);

    const handleClose = useCallback(() => setAnchorEl(null), []);

    const handleSwitchLng = useCallback((language) => {
        handleClose()
        i18n.changeLanguage(language)
    }, [i18n, handleClose])

    const ButtonType = useMemo(() =>
        <Grid container sx={{ justifyContent: 'center' }} >
            {languages.map(language =>
                <Button
                    key={language.value}
                    variant={selectedLanguage === language.value ? "contained" : "text"}
                    onClick={() => handleLanguageChange(language.value)}
                >
                    {language.label}
                </Button>
            )}
        </Grid>,
        [languages, selectedLanguage, handleLanguageChange]
    )

    const DropDownType = useMemo(() =>
        <>
            <Button
                id="language-button"
                sx={{ color: 'text.primary' }}
                aria-controls={open ? 'language-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                {languages.find(x => x.value === selectedLanguage)?.label || "EN"}
            </Button>
            <Menu
                id="language-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'language-button',
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {languages.map((language) =>
                    <MenuItem key={language.value} onClick={() => handleSwitchLng(language.value)} sx={{ minWidth: 100, justifyContent: 'center' }}>
                        {language.label}
                    </MenuItem>
                )}
            </Menu>
        </>,
        [anchorEl, handleClose, languages, open, selectedLanguage, handleSwitchLng]
    )

    return type === "button" ? ButtonType : DropDownType
}

export default LanguageSelector